import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertComponent } from 'src/app/layout/extensions/alert/alert.component';
import { BlogTypeCollectionResponse } from 'src/app/utils/models/landing-page/blog-type-collection-response.model';
import { BlogTypeItem } from 'src/app/utils/models/landing-page/blog-type-item.model';
import { LandingpageService } from 'src/app/utils/services/aas-network/landingpage.service';

@Component({
  selector: 'app-service-landing-page-blog-type',
  templateUrl: './service-landing-page-blog-type.component.html',
  styleUrls: ['./service-landing-page-blog-type.component.scss']
})
export class ServiceLandingPageBlogTypeComponent implements OnInit {

  blogTypes: Array<BlogTypeItem> = [];
  totalElement: number;

  constructor(
    private landingService: LandingpageService,
    private modalService: NgbModal) 
  { }

  ngOnInit(): void {
    this.getBlogTypes();
  }

  getBlogTypes(){
    this.landingService.getBlogTypes()
    .subscribe(
      (res) => {
        const response = new BlogTypeCollectionResponse(res);        
        this.blogTypes = response.data;
        this.totalElement = response.totalElement;
      },
      (err) => {
        console.log(err);
      }
    )
  }

  onDeleteClick(id){
    this.alert(
      "Bạn thực sự muốn xóa?", 
      "", 
      true, 
      "", 
      "Xác nhận", 
      () => {
        this.deleteBlogType(id)
      },
      "",
      "Hủy",
      () => {
        console.log('Người dùng hủy hành động');
      })
  }

  deleteBlogType(id){
    this.landingService.deleteBlogType(id)
    .subscribe(
      (res) => {
         this.alert("Xóa thành công", "success");
         this.getBlogTypes();
      },
      (err) => {
        this.handleError(err, err);
      }
    )
  }

  //MARK: Popup thông báo
  alert(msg, type, twoBtn = false, iconBtn2 = '', titleBtn2 = 'OK', actBtn2 = () => { }, iconBtn1 = '', titleBtn1 = 'Hủy', actBtn1 = () => { }) {
    const modalRef = this.modalService.open(AlertComponent);
    modalRef.componentInstance.message = msg;
    modalRef.componentInstance.typeAlert = type;
    modalRef.componentInstance.twoBtn = twoBtn;
    modalRef.componentInstance.iconBtn1 = iconBtn1;
    modalRef.componentInstance.iconBtn2 = iconBtn2;
    modalRef.componentInstance.titleButton1 = titleBtn1;
    modalRef.componentInstance.titleButton2 = titleBtn2;
    modalRef.componentInstance.callback1 = actBtn1;
    modalRef.componentInstance.callback2 = actBtn2;
  }

  //MARK: Handle Error
  handleError(err, errorMsg) {
    if (err.error && err.error.message && errorMsg[err.error.message]) {
      this.alert(errorMsg[err.error.message], 'error');
    } else if (err.error && err.error.error) {
      this.alert(err.error.error, 'error');
    } else {
      this.alert('Lỗi không xác định! Vui lòng thử lại', 'error');
    }
  }

}
